import { render, staticRenderFns } from "./PatentGeneralTab.vue?vue&type=template&id=0344a3e8"
import script from "./PatentGeneralTab.vue?vue&type=script&lang=js"
export * from "./PatentGeneralTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports